import { useEffect, useState } from 'react'
import { Avatar, Tooltip } from 'antd'
import { equipeOnline } from 'services/collaborator/equipe'
import { getUserCachedData } from 'utils/UserAuthorization'

const iniciais = (nome) => String(nome || '?').trim().split(/\s+/).filter(Boolean).map((p, i, a) => (i === 0 || i === a.length - 1 ? p[0] : '')).join('').toUpperCase()

// Fotos de quem está com o sistema aberto agora (menos você), no topo
export default function EquipeOnline() {
  const [equipe, setEquipe] = useState([])

  useEffect(() => {
    let vivo = true
    const eu = getUserCachedData()?.id
    const carregar = () => equipeOnline()
      .then((lista) => { if (vivo) setEquipe((lista || []).filter((p) => p.id !== eu)) })
      .catch(() => {})
    carregar()
    const t = setInterval(carregar, 60000)
    return () => { vivo = false; clearInterval(t) }
  }, [])

  if (!equipe.length) return null
  return (
    <Avatar.Group max={{ count: 4, style: { background: 'var(--yrm-surface-3)', color: 'var(--yrm-text)', fontSize: 12 } }} size={32}>
      {equipe.map((p) => (
        <Tooltip key={p.id} title={[p.nome, p.cargo].filter(Boolean).join(' · ') + ' · online'}>
          <Avatar src={p.foto || undefined} style={{ background: '#2a2d5c', color: '#f1ede2', fontSize: 12, fontWeight: 600, border: '2px solid var(--yrm-chrome-bg)' }}>
            {iniciais(p.nome)}
          </Avatar>
        </Tooltip>
      ))}
    </Avatar.Group>
  )
}
